<div class="login-screen">
    <div class="row m-0">
        <div class="col-lg-7 p-0">
            <div class="contentLogin">
                <div class="logo-header">
                    <img src="assets/images/logo.svg" class="img-fluid" alt="" srcset="">
                    <h5 class="m-0">Don't have an account? &nbsp;<a href="#" class="fw-medium">Sign up!</a></h5>
                </div>
                <div class="loginbox">
                    <h2 class="text-left mb-4  fw-light">Enter the code</h2>
                    <h5 class="text-left  fw-normal">Enter the 6 digit verification code we sent to alpha...gmail.com.</h5>
                    <form class="login-form">
                        <!-- <div class="enter-code my-3">
                            <div class="box">3</div>
                            <div class="box">5</div>
                            <div class="box">9</div>
                            <div class="box">-</div>
                            <div class="box">-</div>
                            <div class="box">-</div>
                        </div> -->
                        <div class="form-group mb-3 d-flex align-items-center justify-content-center gap-4 text-center otp-bar flex-nowrap whitespace-nowrap">
                            <ng-otp-input (onInputChange)="onOtpChange($event)" #ngOtpInput
                                [config]="config"></ng-otp-input>
                        </div>
                        <!-- <h5 class="m-0  fw-normal">Remaining Attempts 1/4</h5> -->
                  
                        <button mat-flat-button color="primary" class="my-3 w-100" (click)="openDialog($event)">Verify code</button>
                        <div class="d-flex align-items-center justify-content-between w-100 gap-3 mt-2">
                            <p class="m-0">Haven't got the email yet? <a href="#" class="text-decoration-underline">Resend Code</a></p>
                             <!-- <a href="#" class="text-decoration-underline text-danger">Report</a> -->
                        </div>
                    </form>
                </div>
            </div>
          
        </div>
        <div class="col-lg-5 p-0">
            <div class="recoverimage-height image-height">
              <p>&nbsp;</p>
            </div>
        
        </div>
    </div>
</div>

